/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';

import { getPriceGroupConfig } from 'services/pricelist/groups';

import { useLanguage } from './useLanguage';

export const usePriceListConfig = () => {
  const language = useLanguage();

  const priceListGroups = useMemo(() => getPriceGroupConfig(), [language]);

  return {
    groups: priceListGroups
  };
};
